<template>
	<div>
		<el-form :model="article" :rules="rules" style="text-align:left" label-position="right" label-width="180px" ref="article"  size="small" >
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="文章标题" prop="title">
							<el-input v-model="article.title"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="背景图" prop="imgSource">
							<el-upload
							  class="upload-demo"
							  list-type="picture-card"
							  :show-file-list="false"
							  action="/api/img/upload"
							  :limit="1"
							  :on-remove="handleRemove"
							  :on-success="handleAvatarSuccess"
							  >
							  <img v-if="article.imgSource" :src="article.imgSource" class="avatar" height="87px" width="98px" />
  								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="内容" >
					<div id="editor"></div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="backToLisk">返回</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
	</div>
</template>
<style type="text/css">
	
	.el-upload{
		height: 87px;
		width: 98px;
		line-height: 87px;
	}
</style>
<script>
	import {getArticle,addArticle} from '@/api/api.js'
	import tools from "@/tools"
	import Editor from 'wangeditor'
	import 'wangeditor/release/wangEditor.min.css'
	export default {
		components:{
			Editor
		},
		data(){
			return {
				article:{
					id:'',
					content:'',
					imgSource:"",
					title:""
				},
				rules: {
		          content: [
		            { required: true, message: '请输入公司名称', trigger: 'blur' }
		          ],
		          imgSource: [
		            { required: true, message: '请输入联系人姓名', trigger: 'blur' }
		          ],
		          title: [
		            { required: true, message: '请输入联系人电话', trigger: 'blur' }
		          ]
		        },
				addLoading:false
			}

		},
		mounted(){
            this.editor = new Editor("#editor");
            this.editor.customConfig.uploadImgServer="/api/img/upload";
            this.editor.customConfig.uploadFileName = 'file';
            this.editor.customConfig.uploadImgHooks = {
            	success: function (xhr, editor, result) {
            		
    			},
            	customInsert: function (insertImg, result, editor) {
			        var url = result.data;
			        insertImg(url);
    			}
            };
            this.editor.create()
		},
		created:function() {
			var id = this.$route.query.id;
			
			if(id){
				getArticle({id:id}).then(res=>{
					this.article = res.data.data;
					this.editor.txt.html(this.article.content);
				})
			};
			
		},
		methods:{
			addSubmit(){
				
				this.$refs["article"].validate((valid)=>{
					this.addLoading=true;
					this.article.content=this.editor.txt.html();
					if(valid){
						addArticle(this.article).then(res=>{
							if(res.data.status=="success"){
								this.$message('添加成功');
								this.addLoading=false;
								this.$router.go(-1);
							}
						});	
					};
					this.addLoading=false;	
				});
			},
			handleAvatarSuccess(res, file,fileList) {
				this.article.imgSource=res.data;
				console.log(this.article.imgSource);
		    },
		    handleRemove(file, fileList){


		    },
		    backToLisk(){
		    	this.$router.go(-1);
		    }
		}
	}
</script>